import { render } from "./dashboardAppointments.vue?vue&type=template&id=8a743888&scoped=true"
import script from "./dashboardAppointments.vue?vue&type=script&lang=js"
export * from "./dashboardAppointments.vue?vue&type=script&lang=js"

import "./dashboardAppointments.vue?vue&type=style&index=0&id=8a743888&lang=scss&scoped=true"
import "./dashboardAppointments.vue?vue&type=style&index=1&id=8a743888&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a743888"]])

export default __exports__